import React, { useState } from "react"

import { useQuery } from "@tanstack/react-query"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DateTime } from "luxon"

import { ButtonGroup } from "@/components/ui/button-group.tsx"
import { Button } from "@/components/ui/button.tsx"
import { Separator } from "@/components/ui/separator.tsx"

import { getFarms } from "../api/getFarms.ts"

import FarmTargetRow from "./FarmTargetRow.tsx"

export default function FarmTargets() {
  const { data, isPending, isError } = useQuery({
    queryKey: ["farms"],
    queryFn: getFarms,
  })

  const [date, setDate] = useState<Date>(DateTime.now().startOf("month").toJSDate())

  if (isPending || isError) return <></>

  const handleNext = () => {
    setDate(DateTime.fromJSDate(date).plus({ month: 1 }).toJSDate())
  }

  const handlePrevious = () => {
    setDate(DateTime.fromJSDate(date).minus({ month: 1 }).toJSDate())
  }

  return (
    <div className="flex flex-col gap-2 mt-2">
      <div className="flex gap-4 items-center">
        <ButtonGroup>
          <Button variant="outline" onClick={handlePrevious}>
            <ChevronLeft />
          </Button>
          <Button variant="outline" onClick={handleNext}>
            <ChevronRight />
          </Button>
        </ButtonGroup>
        <div className="font-semibold">{DateTime.fromJSDate(date).toFormat("LLLL yyyy")}</div>
      </div>
      <div className="rounded-md border shadow-sm p-4 flex flex-col">
        {data.map((farm, i) => (
          <React.Fragment key={i}>
            <FarmTargetRow
              farm={farm}
              key={`${farm.id}-${date.getFullYear()}-${date.getMonth() + 1}`}
            />
            {i != data.length - 1 && <Separator />}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}
